module.exports = __webpack_public_path__ + "img/verify4.7910f4f0.jpg";